let currentPropertyFilterRequest = null;

jQuery(document).on('click', '.js-coming-soon-location-filter', function (event) {
  const $input = jQuery(event.currentTarget).siblings('input[name="location[]"]');
  const $form = jQuery(event.currentTarget).closest('form.js-property-filter');
  const locationUrls = JSON.parse($form.attr('data-coming-soon-location-urls') || '{}');
  const locationUrl = locationUrls[$input.val()];

  if (locationUrl) {
    event.preventDefault();
    window.location.href = locationUrl;
  }
});

function propertyFiltersAjaxRequest(data, successCallback, errorCallback) {
  if (currentPropertyFilterRequest && currentPropertyFilterRequest.readyState !== 4) {
    currentPropertyFilterRequest.abort();
  }

  const $filterForm = jQuery('.js-property-filter');

  const targetHref = $filterForm.attr('data-rest-url');
  if (!targetHref) {
    console.warn('No target href');
    return;
  }

  const targetElement = $filterForm.attr('data-rest-target');
  if (!targetElement) {
    console.warn('No target element');
    return;
  }

  currentPropertyFilterRequest = jQuery.ajax({
    url: targetHref,
    method: 'GET',
    data: data,
    success: function (response) {
      jQuery(targetElement).replaceWith(response.content);

      typeof successCallback === 'function' && successCallback(response);

      const url = new URL(window.location);
      url.search = data;
      window.history.pushState({}, '', url);
    },
    error: function (xhr, status, error) {
      console.error(error);
      typeof errorCallback === 'function' && errorCallback(xhr, status, error);
    },
  });
}

function propertyFilterReset() {
  $form = jQuery('.js-property-filter');

  $form.find('input[type="checkbox"]').prop('checked', false);
  $form.find('input[type="checkbox"][name="location[]"]').first().prop('checked', true);
  $form.find('input[type="checkbox"][name="room_count[]"]').first().prop('checked', true);

  $priceSlider = jQuery('#price-slider');
  $priceSlider[0].noUiSlider.set([
    parseInt($priceSlider.attr('data-price-slider-start-min'), 10),
    parseInt($priceSlider.attr('data-price-slider-start-max'), 10),
  ]);
}

jQuery(document).on('click', '.js-property-filter', function (event) {
  if (event.target.nodeName !== 'INPUT') {
    return;
  }

  const $currentTarget = jQuery(event.currentTarget);

  if (event.target.name === 'location[]' && event.target.value !== '') {
    const locationUrls = JSON.parse($currentTarget.attr('data-coming-soon-location-urls') || '{}');
    const locationUrl = locationUrls[event.target.value];

    if (locationUrl) {
      event.preventDefault();
      window.location.href = locationUrl;
      return;
    }
  }

  let targetData = $currentTarget.serializeArray();

  if (event.target.type === 'checkbox') {
    const targetCheckboxValue = event.target.value;
    if (targetCheckboxValue === '') {
      targetData = targetData.filter(function (item) {
        return item.name !== event.target.name;
      });
    }
  }

  const data = jQuery.param(targetData);

  propertyFiltersAjaxRequest(data);
});

jQuery(document).on(
  'input change',
  'form.js-property-filter input#min_price, form.js-property-filter input#max_price',
  function (event) {
    event.preventDefault();

    const $filterForm = jQuery('.js-property-filter');

    const temp = $filterForm.attr('data-property-filter-skip-nouislider');
    if (temp === '1') {
      return;
    }

    let targetData = $filterForm.serializeArray();

    const data = jQuery.param(targetData);

    propertyFiltersAjaxRequest(data);
  }
);

jQuery(document).on('click', '.js-property-filter-clear', function (event) {
  event.preventDefault();

  const $filterForm = jQuery('.js-property-filter');
  $filterForm.attr('data-property-filter-skip-nouislider', '1');
  propertyFiltersAjaxRequest([], function () {
    propertyFilterReset();
    $filterForm.attr('data-property-filter-skip-nouislider', '0');
  });
});

jQuery(document).on('click', '.js-property-filter-view-more', function (event) {
  event.preventDefault();

  const $filterForm = jQuery('.js-property-filter');

  const $perPage = $filterForm.find('input[name="per_page"]');
  if ($perPage.length) {
    // const currentPerPage = parseInt($perPage.val(), 10);
    // $perPage.val(currentPerPage + 6);
    $perPage.val(-1);
  }

  let targetData = $filterForm.serializeArray();

  const data = jQuery.param(targetData);

  propertyFiltersAjaxRequest(data);
});

jQuery(document).on('click', '.js-product-filter-order', function (event) {
  event.preventDefault();

  const $currentTarget = jQuery(event.currentTarget);

  const direction = $currentTarget.attr('data-product-filter-order');

  const newDirection = direction === 'asc' ? 'desc' : 'asc';

  $currentTarget.attr('data-product-filter-order', newDirection);

  const $filterForm = jQuery('.js-property-filter');

  $filterForm.find('input[name="order"]').val(newDirection);

  let targetData = $filterForm.serializeArray();

  const data = jQuery.param(targetData);

  propertyFiltersAjaxRequest(data);
});

jQuery(document).on('click', '.js-product-filter-order-by', function (event) {
  const $currentTarget = jQuery(event.currentTarget);
  const $currentTargetOrderByInput = $currentTarget.find('input[name="order_by"]');

  const $propertiesFilterForm = jQuery('.js-property-filter');
  $propertiesFilterForm.find('input[name="order_by"]').val($currentTargetOrderByInput.attr('value'));

  const arr = $propertiesFilterForm.serializeArray();

  const data = jQuery.param(arr);

  propertyFiltersAjaxRequest(data);
});

document.addEventListener('DOMContentLoaded', function () {
  // Generic handler for all checkbox groups with an "All" option
  const handleCheckboxGroup = (groupName) => {
    const checkboxes = document.querySelectorAll(`input[name="${groupName}"]`);
    if (!checkboxes.length) return;

    const allBox = [...checkboxes].find((cb) => cb.value === '');

    checkboxes.forEach((cb) => {
      cb.addEventListener('change', () => {
        if (cb === allBox && cb.checked) {
          // Deselect all others
          checkboxes.forEach((other) => {
            if (other !== cb) other.checked = false;
          });
        } else if (cb !== allBox && cb.checked) {
          // Deselect the "All" checkbox
          if (allBox) allBox.checked = false;
        }
      });
    });
  };

  // Run for both groups
  handleCheckboxGroup('location[]');
  handleCheckboxGroup('room_count[]'); // Adjust name below if needed
});

document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.custom-dropdown');

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.dropdown-menu');
    const selected = dropdown.querySelector('.dropdown-selected');
    const hiddenInput = dropdown.querySelector('.dropdown-input');
    const items = Array.from(menu.querySelectorAll('[role="option"]'));

    let focusedIndex = -1;

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = !menu.classList.contains('hidden');
      closeAllMenus();
      if (!isOpen) {
        menu.classList.remove('hidden');
        toggle.setAttribute('aria-expanded', 'true');

        focusedIndex = items.findIndex((i) => i.dataset.value === hiddenInput.value);
        if (focusedIndex >= 0) {
          setActiveDescendant(items[focusedIndex]);
          items[focusedIndex].focus();
        }
      }
    });

    items.forEach((item, index) => {
      item.setAttribute('tabindex', '0');
      item.addEventListener('click', () => selectItem(item));
      item.addEventListener('keydown', (e) => {
        switch (e.key) {
          case 'Enter':
          case ' ':
            e.preventDefault();
            selectItem(item);
            break;
          case 'Escape':
            e.preventDefault();
            closeMenu();
            toggle.focus();
            break;
          case 'ArrowDown':
            e.preventDefault();
            focusNext(index + 1);
            break;
          case 'ArrowUp':
            e.preventDefault();
            focusNext(index - 1);
            break;
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) closeMenu();
    });

    function selectItem(item) {
      selected.textContent = item.textContent;
      hiddenInput.value = item.dataset.value;
      items.forEach((i) => i.removeAttribute('aria-selected'));
      item.setAttribute('aria-selected', 'true');
      setActiveDescendant(item);
      closeMenu();
      toggle.focus();
    }

    function closeMenu() {
      menu.classList.add('hidden');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.removeAttribute('aria-activedescendant');
    }

    function closeAllMenus() {
      document.querySelectorAll('.dropdown-menu').forEach((m) => m.classList.add('hidden'));
      document.querySelectorAll('.dropdown-toggle').forEach((t) => t.setAttribute('aria-expanded', 'false'));
    }

    function focusNext(index) {
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      focusedIndex = index;
      items[focusedIndex].focus();
      setActiveDescendant(items[focusedIndex]);
    }

    function setActiveDescendant(item) {
      toggle.setAttribute(
        'aria-activedescendant',
        item.id || (item.id = `opt-${Math.random().toString(36).slice(2, 8)}`)
      );
    }
  });
});
